var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, } from "@material-ui/core";
export var useConfirmationDialog = function (_a) {
    var open = _a.open, onConfirm = _a.onConfirm, message = _a.message;
    var _b = React.useState(open), isOpen = _b[0], setOpen = _b[1];
    var close = function () { return setOpen(false); };
    var confirm = function () {
        close();
        onConfirm();
    };
    return {
        open: function () { return setOpen(true); },
        Dialog: function (props) { return (React.createElement(Dialog, __assign({ open: isOpen, onClose: close }, props),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, message)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: close, color: "primary" }, "\u041D\u0435\u0442"),
                React.createElement(Button, { onClick: confirm, color: "primary", autoFocus: true }, "\u0414\u0430")))); },
    };
};
